import Vue from 'vue'
import Vuex from 'vuex'
import { analyticsMiddleware } from 'vue-analytics'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
  categories: [],
  categoriesTree: [],
  addresses: [],
  totalProducts: 0,
  productsCache: {},
  products: [],
  loadedCategory: '',
  searchResult: [],
  bestsellers: [],
  latestProducts: [],
  currentSearch: null,
  pagination: {
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
    linkRadius: 5,
    total: 0,
    maxLinks: 10,
  },
  authToken: '',
  user: {
    authenticated: false,
    firstname: null,
    lastname: null,
    email: null,
    is_admin: false,
    discount: 0,
  },
  account: {},
  orderBy: 'id',
  orderByDirection: 'desc',
  cart: [],
  expandedProductViewID: {
    products: null,
    latestProducts: null,
    bestsellers: null,
  },
  addressbook: {
    billing_country_id: 198,
    shipping_country_id: 198,
  },
  countries: [],
  checkingAuth: false,
  cartScreen: 1,
  admin: {
    authors: [],
    publishers: [],
  },
  adminProducts: [],
  adminProductsPagination: {
    currentPage: 1,
    lastPage: 1,
    linkRadius: 5,
    total: 0,
    filters: {
      perPage: 25,
      orderBy: 'id',
      orderByDirection: 'desc',
      status: 0,
      discount: 0,
      selectedCategory: 'all',
    },
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [analyticsMiddleware],
  strict: true,
})

// export const store = new Vuex.Store({
//   state,
//   getters,
//   mutations,
//   actions
// })
